module.exports = __webpack_public_path__ + "img/pantalla7-1.923d33e6.png";